import {Component, OnInit} from "@angular/core";
import {Title} from "@angular/platform-browser";
import { Router, NavigationEnd } from '@angular/router';
import {TranslateService} from "@ngx-translate/core";
import {filter, map} from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private titleService: Title,
    private translate: TranslateService
  ) {
    translate.setDefaultLang("fr-FR");
    translate.use("fr-FR");
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this.router.routerState.root;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route.snapshot.data['title'];
        })
      )
      .subscribe((title: string) => {
        if (title) {
          this.translate.stream(title).subscribe(translatedTitle => {
            this.titleService.setTitle(translatedTitle);
          });
        }
      });
  }
}
